import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useStatus } from '../../../__legacy__/components/core/Utils'
import { useAsyncEffect } from '../../../__legacy__/components/platform/explore/common/utils'
import { IArpMedia } from '../../arp-registry/ArpMedia'
import ArpRegistry from '../../arp-registry/ArpRegistry'

export const useMediaDetails = () => {
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token')
  const [status, setStatus] = useStatus('loading')
  const [media, setMedia] = useState<IArpMedia>()
  useAsyncEffect(async () => {
    setStatus('loading')
    const media = await ArpRegistry.getByIdAsync(token, true)
    if (!media) return setStatus('error')
    setMedia(media)
    setStatus('ready')
  }, [token])
  return { status, media }
}
